/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

import requsetMarketPlace from 'utils/requestMatketPlace';

const categoryService = {
  getList: (params: any) => request.get('/guidebook/category', { params }),
  getCategoryById: (id: any) => request.get(`/guidebook/category/${id}`),
  createCategory: (data: any) => request.post('/guidebook/category', data),
  deleteCategory: (id: any) => request.delete(`/guidebook/category/${id}`),
  updateCategory: (id: any, data: any) =>
    request.put(`/guidebook/category/${id}`, data),

  getCategoryAttributesById: (id: any, params: any) =>
    requsetMarketPlace.get(`/system-category-specification/${id}`, {
      params
    }),
  updateCategoryAttributesById: (id: any, data: any) =>
    requsetMarketPlace.put(`/system-category-specification/${id}`, data)
};

export default categoryService;
